<template>
  <v-container fluid>
    <el-textarea v-if="showSeeder" label="Seeder input" v-model="seederInput" />
    <el-button
      v-if="showSeeder"
      @click.native="importSeeder()"
      :loading="loading"
      >generuoti</el-button
    >
    <br />
    <el-textarea v-if="showSeeder" label="Seeder duomenys" v-model="seeder" />

    <v-data-table
      :headers="filteredHeaders"
      :items="filteredItemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :page.sync="page"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <el-button
            @click.native="printData(`admin/tooltip/print`, `Tooltip ${grupe}`)"
            :loading="loading"
            >Eksportuoti į excel</el-button
          >

          <template v-if="isLocal">
            <el-button v-if="showSeederButton" @click.native="openSeeder()">
              DB export
            </el-button>
            <el-button-prideti
              :disabled="isSearch"
              primary
              @click.native="addItem()"
            >
              Pridėti paaiškinimą
            </el-button-prideti>
          </template>
        </v-toolbar>
      </template>
      <template #[`item.too_aktyvus`]="{ item }">
        <el-switch v-model="item.too_aktyvus" />
      </template>
      <template #[`item.too_tekstas`]="{ item }">
        <div class="text-cut-4">
          <span class="tooltip-santrauka" v-html="item.too_tekstas"></span>
        </div>
      </template>
      <template #[`item.aktyvus_label`]="{ item }">
        <el-busena :busena="item.aktyvus_label" :color="item.aktyvus_color" />
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @deleteItem="deleteItem(item)"
        />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-tooltip
      :key="modalTooltipKey"
      :readonly="modalTooltipReadonly"
      v-model="showTooltip"
      :item="modalTooltip"
      :grupe="grupe"
      @savedData="savedTooltip"
      @canceledData="canceledTooltip"
    />
    <modal-delete
      :title="deleteTile"
      :text="`Ar norite pašalinti <strong>${modalDeleteVardas}</strong>?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import ModalTooltip from '../modals/ModalTooltip'
import ModalDelete from '../modals/ModalDelete'
import print from '../../mixins/print'

export default {
  name: 'AdminTooltipDetail',
  props: {
    grupe: String,
  },
  components: { ModalTooltip, ModalDelete },
  mixins: [print],
  data() {
    return {
      pageloading: true,
      loading: true,
      tooltips: [],
      search: null,
      itemsPerPageOptions: [20, 50, 100],
      pageSize: 20,
      page: 1,
      seeder: null,
      seederInput: null,
      showSeeder: false,
      modalTooltip: {},
      modalTooltipReadonly: false,
      showTooltip: false,
      modalTooltipRefresh: 0,
      showDelete: false,
      modalDeleteVardas: null,
      modalDeleteItem: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Kodas',
          align: 'start',
          sortable: false,
          value: 'too_kodas',
          width: 400,
        },
        {
          text: 'Tekstas',
          align: 'start',
          sortable: false,
          value: 'too_tekstas',
        },
        {
          text: 'Aktyvus',
          align: 'center',
          value: 'aktyvus_label',
          width: 100,
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 100,
        },
      ]
    },
    isAprasymas() {
      return this.grupe === 'aprasymas'
    },
    isNtrPaslaugos() {
      return this.grupe === 'ntrpaslaugos'
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filteredItemsList() {
      return this.itemsList.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.tooltips.map(item => {
        item.aktyvus_label = item.too_aktyvus ? 'Taip' : 'Ne'
        item.aktyvus_color = item.too_aktyvus ? 'green' : 'default'

        const itemAprasymas = item.too_kodas
          .toLowerCase()
          .startsWith('aprašymas.')
        const itemNtrPaslaugos = item.too_kodas
          .toLowerCase()
          .startsWith('ntrpaslaugos.')

        if (this.isAprasymas) {
          item.hide = !itemAprasymas
        } else if (this.isNtrPaslaugos) {
          item.hide = !itemNtrPaslaugos
        } else {
          item.hide = itemAprasymas || itemNtrPaslaugos
        }

        item.aktyvus = itemAprasymas

        item.canEdit = true
        item.canDelete = this.isLocal
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isSearch() {
      return this.search != null && this.search.length > 0
    },
    showSeederButton() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop'
      )
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    modalTooltipKey() {
      return 'tooltip-' + this.modalTooltipRefresh
    },
    deleteTile() {
      return this.isAprasymas ? 'Šalinti aprašymą' : 'Šalinti patartį (tooltip)'
    },
    searchData() {
      return this.grupe
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`admin/tooltip`)
        .then(res => {
          this.tooltips = res.data.tooltips
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    addItem() {
      this.openTooltip(null)
    },
    editItem(item) {
      this.openTooltip(item)
    },
    openTooltip(item) {
      if (item) {
        this.modalTooltip = {
          ...item,
        }
      } else {
        this.modalTooltip = {}
      }

      this.modalTooltipRefresh++
      this.showTooltip = true
    },
    savedTooltip() {
      this.getData()
    },
    canceledTooltip() {
      //
    },

    saveData(toRoute) {
      this.loading = true
      this.generateSeeder()

      let data = {
        tooltips: this.tooltips,
        export: this.seeder,
      }

      this.$axios
        .post(`admin/tooltip`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
          this.$store.dispatch('loadTooltips')
          if (toRoute) {
            this.goToRoute()
          } else {
            this.initialForm()
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },

    deleteItem(item) {
      this.modalDeleteVardas = item.too_kodas
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      if (item.too_id > 0) {
        this.$axios
          .delete(`admin/tooltip/${item.too_id}`)
          .then(res => {
            window._VMA.$emit('DATA_OK', res.data.message)
            this.$store.dispatch('loadTooltips')
            this.getData()
          })
          .catch(err => {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          })
          .finally(() => {})
      }

      this.loading = false
    },

    generateSeeder() {
      this.seeder = `private $tooltips = [\n`
      const count = this.tooltips.length
      this.tooltips.forEach((item, index) => {
        this.seeder +=
          `[\n` +
          `    'too_kodas' => '${item.too_kodas.trim()}',\n` +
          `    'too_tekstas' => '${
            item.too_tekstas
              ? item.too_tekstas.trim().replaceAll('\\n', '\'."\\n".\'')
              : ''
          }',\n` +
          `    'too_aktyvus' => ${item.too_aktyvus},\n` +
          `],\n`
      })
      this.seeder += `];`
    },
    importSeeder() {
      if (this.seederInput) {
        this.tooltips = []
        this.seederInput.split('\n').forEach((row, index) => {
          let item = row.split('\t')
          if (item[0].length > 0) {
            this.tooltips.push({
              too_kodas: item[0],
              too_tekstas: item[1],
              too_aktyvus: true,
            })
          }
        })
        this.generateSeeder()
      }
    },
    openSeeder() {
      this.generateSeeder()
      this.showSeeder = true
    },
  },
}
</script>
<style lang="scss">
.tooltip-santrauka p {
  margin-bottom: 3px;
}
</style>
